import { render, staticRenderFns } from "./OrganizationMemberships.vue?vue&type=template&id=533a7a86"
import script from "./OrganizationMemberships.vue?vue&type=script&lang=js"
export * from "./OrganizationMemberships.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports